import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AudienciaService } from "../../services/audiencia-service";
import { ProcessoService } from "../../services/processo-service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

@Component({
    selector: 'app-novo-audiencia',
    templateUrl: './novo.component.html',
    styleUrl: './novo.component.css',
    standalone: false
})
export class NovoComponent implements OnInit {
  @Input() isModal = false;
  @Input() isModalDetalhes = false;

  @Output() atualizarLista = new EventEmitter();
  modalNovoAudiencia = false;
  loading = false;
  formCadastrar: FormGroup;
  listaProcessos: any[] = [];

  constructor(private audienciaService: AudienciaService,
              private processoService: ProcessoService,
              private formBuilder: FormBuilder,
              private router: Router,
              private toastr: ToastrService) {
    this.construirFormulario();
  }

  ngOnInit(): void {
    if (!this.isModal) {
      this.listarProcessos();
    }
  }

  showModal() {
    this.modalNovoAudiencia = true;
    this.listarProcessos();
  }

  voltar() {
    if (this.isModal) {
      this.fecharModal();
    } else {
      this.router.navigate(['/juridico/audiencia']);
    }
  }

  fecharModal() {
    this.modalNovoAudiencia = false;
    this.formCadastrar.reset();
  }

  listarProcessos() {
    this.processoService.selecionarLista().subscribe((response: any) => {
      if (response.sucesso) {
        this.listaProcessos = response.dados.itens;
      }
    });
  }

  salvar() {
    if (this.formCadastrar.invalid) {
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;

        const dados = this.formCadastrar.value;
        const request = {
          processoId: dados.processoId,
          dataInicio: `${dados.dataAudiencia}T${dados.horaAudiencia}:00.000Z`,
          documentoAutosId: 0,
          id: 0,
          origemId: 0,
          local: dados.local
        };

        this.audienciaService.adicionar(request).subscribe(
          (response: any) => {
            this.loading = false;
            if (response.sucesso) {
              this.toastr.success("Audiência salva com sucesso");
              this.fecharModal();
              this.atualizarLista.emit();
            } else {
              this.toastr.error("Erro ao salvar audiência");
            }
          },
          (error: any) => {
            this.loading = false;
            this.toastr.error("Erro ao salvar audiência");
          }
        );
      }
    });
  }

  private construirFormulario() {
    this.formCadastrar = this.formBuilder.group({
      dataAudiencia: [null, [Validators.required]],
      horaAudiencia: [null, [Validators.required]],
      processoId: [null, [Validators.required]],
      local: [null, [Validators.required]]
    });
  }
}
